import {
  Alert,
  AlertIcon,
  Box,
  ChakraProps,
  Flex,
  Heading,
  Link,
  Spacer,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';

const getTitle = ({
  editMode,
  title,
}: {
  title?: string;
  editMode: boolean;
}) => {
  if (title) {
    return title;
  }
  return editMode ? 'Edit Assignments' : 'Assignments';
};

type AssignmentHeaderProps = {
  editMode: boolean;
  children?: React.ReactNode;
  headerTitle?: string;
};
export const AssignmentHeader = ({
  children,
  editMode,
  headerTitle,
}: AssignmentHeaderProps) => {
  return (
    <Flex>
      <Heading as="h2" mb="1rem">
        {getTitle({ editMode, title: headerTitle })}
      </Heading>
      <Spacer />
      {children}
    </Flex>
  );
};

type AssignmentTemplateProps = {
  headerChildren?: React.ReactNode; // children for the top header, eg. buttons
  children: React.ReactNode; // children for the main content page
  bg?: ChakraProps['bg'];
  editMode?: boolean;
  headerTitle?: string;
};
export const AssignmentTemplate = ({
  headerChildren,
  children,
  editMode = false,
  bg,
  headerTitle,
}: AssignmentTemplateProps) => {
  return (
    <>
      <Box background={colors.white}>
        <AssignmentHeader headerTitle={headerTitle} editMode={editMode}>
          {headerChildren}
        </AssignmentHeader>
      </Box>

      <Box bg={bg}>{children}</Box>
    </>
  );
};

type AssignmentHighlightBoxProps = { children: React.ReactNode };
export const AssignmentHighlightBox = ({
  children,
}: AssignmentHighlightBoxProps) => {
  return (
    <Box
      background="white"
      borderRadius="8px"
      padding="32px"
      mb="32px"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
    >
      {children}
    </Box>
  );
};

export const AssignmentIncompleteCurrentMasterLoanTapeSetAlert = () => {
  return (
    <Box height="100%">
      <AssignmentTemplate>
        <Alert status="warning" background="transparent">
          <Box>
            <Text mt="30px" mb="30px">
              All loan products for the organization must have a current master
              loan tape for the same reporting date and file version.
            </Text>
            <Flex>
              <AlertIcon />
              <Text>
                Please upload the necessary loan tapes on the{' '}
                <Link
                  as={RouterLink}
                  to="/data-pipeline"
                  style={{ textDecoration: 'underline' }}
                >
                  Data Pipeline
                </Link>{' '}
                page.
              </Text>
            </Flex>
          </Box>
        </Alert>
      </AssignmentTemplate>
    </Box>
  );
};
